import { css } from '@emotion/core'

import { rwd } from './rwd'

export const rwdMenuSpacingForTitle = css`
  ${rwd.equalOrLessThan('xlarge')} {
    margin-left: 121px;
  }
`
